<div class="p-t-md container-fluid">

  <div class="row">
    <!-- Events to validate / validated -->
    <div class="col-md-4" gp-ui-expandable-box>
      <div class="gp-box-header">
        <div class="pull-left m-r">
          <span class="w-40 rounded warn">
            <i class="fa-solid fa-list-check"></i>
          </span>
        </div>
        <div class="clear">
          <h3>
            {{ 'PAYROLL_EVENTS._events_to_validate' | translate:{statisticsToValidate: statistics?.toValidate || 0} }}
          </h3>
          <small>
            {{ 'PAYROLL_EVENTS._events_validated' | translate:{statisticsValidated: statistics?.validated || 0} }}
          </small>
        </div>
      </div>
      <div class="gp-box-body">
        <gp-echart
          [width]="'100%'"
          [height]="'300px'"
          [options]="payEventsPerDomainChart">
        </gp-echart>
      </div>
    </div>

    <!-- Alerts / errors -->
    <div class="col-md-4" gp-ui-expandable-box>
      <div class="gp-box-header">
        <div class="pull-left m-r">
          <gp-graph-pie-chart [width]="40" [height]="40" [data]="payEventStatusHeaderChartData">
          </gp-graph-pie-chart>
        </div>
        <div class="clear">
          <h3>
            {{ 'PAYROLL_EVENTS._alerts__errors' | translate:{
            statisticsCountsByTypeAlert:
              statistics?.countsByType?.alert || 0, statisticsCountsByTypeError: statistics?.countsByType?.error || 0
          }
            }}
          </h3>
          <small>
            {{ 'PAYROLL_EVENTS._warnings__information' | translate:{
            statisticsCountsByTypeWarning:
              statistics?.countsByType?.warning || 0, statisticsCountsByTypeInformation:
              statistics?.countsByType?.information || 0
          } }}
          </small>
        </div>
      </div>
      <div class="gp-box-body">
        <gp-echart
          [height]="'300px'"
          [width]="'100%'"
          [options]="payEventsStatusChart"
          (datumClick)="router.navigate(['payroll/calculation-events'], {queryParams: {eventType: $event.key}})">
        </gp-echart>
      </div>
    </div>

    <!-- Calculate / review box-->
    <div class="col-md-4" gp-ui-expandable-box>
      <div class="gp-box-header">
        <div class="pull-left m-r">
          <span class="w-40 rounded primary">
            <i class="fa-solid fa-grip-vertical"></i>
          </span>
        </div>
        <div class="clear">
          <h3>{{ 'PAYROLL_EVENTS.seven_days_before_closing' | translate }}</h3>
          <small>{{ 'PAYROLL_EVENTS.twelve_days_before_next_closing' | translate }}</small>
        </div>
      </div>
      <div class="gp-box-body">
        <gp-echart
          [height]="'300px'"
          [width]="'100%'"
          [options]="payEventsHistoricChart"></gp-echart>
      </div>
    </div>
  </div>

  <div class="box shadow">
    <div class="box-header">
      <h3>{{ 'PAYROLL_EVENTS.validation_plan' | translate }}
        <span class="dropdown"
              [class.open]="menuOpened"
              (click-outside)="menuOpened = false">
          <button class="btn btn-outline" type="button" (click)="menuOpened = !menuOpened">
            <span class="fa fa-light fa-ellipsis-v"></span>
          </button>
          <ul class="dropdown-menu">
            <li class="dropdown-item" (click)="exportToCSV(); menuOpened = false">
              <a>{{'ADMINISTRATION.export_to_csv' | translate}}</a>
            </li>
          </ul>
        </span>
      </h3>
      <div class="pull-right">
        <i class="m-l fa fa-light fa-sync pointer" (click)="fetchEvents()"></i>
      </div>
    </div>

    <div class="box-body">
      <div class="row m-b">
        <div class="pull-left m-l">
          <!-- done -->
          <div class="btn-group">
            <button class="btn btn-sm btn-outline-primary"
                    [class.active]="isTodo"
                    (click)="toggleSeeDone()">
              {{ 'COMMON.todo' | translate }}
            </button>
            <button class="btn btn-sm btn-outline-primary"
                    [class.active]="!isTodo"
                    (click)="toggleSeeDone()">
              {{ 'COMMON.done' | translate }}
            </button>
          </div>
        </div>
      </div>
      <gp-table [formGroup]="filterFormGroup" (sortChange)="onSortKeyChange($event)" #table>
        <thead gp-table-head>
        <tr role="row" class="column-title">
          <th gp-table-column width="120">{{ 'EMPLOYEE_MANAGE.pay_type' | translate }}</th>
          <th gp-table-column sort-key="payRollSerieName" default-sort="asc" width="180">
            {{ 'COMMON.payroll' | translate}}
          </th>
          <th gp-table-column width="50">{{ 'FORMS.id' | translate }}</th>
          <th gp-table-column sort-key="cliEmpLastName" width="120">{{ 'FORMS.name' | translate }}</th>
          <th gp-table-column sort-key="payExec" width="120">{{ 'PAYROLL_EVENTS.calculation' | translate }}</th>
          <th gp-table-column sort-key="nameEvent" width="170">{{ 'PAYROLL_EVENTS.rule' | translate }}</th>
          <th gp-table-column sort-key="eventType" width="50">
            <i class="fa fa-light fa-bell m-x-xs"
               [popover]="alertTypes"
               popoverTitle="{{ 'TOOLTIPS.alert_type' | translate }}"
               triggers="mouseenter:mouseleave"
               container="body">
            </i>
            <ng-template #alertTypes>
              <div>
                <i class="fa fa-light fa-bell m-x-xs text-black"></i>
                {{ 'DROPDOWN.Error' | translate }}
              </div>
              <div>
                <i class="fa fa-light fa-bell m-x-xs text-danger"></i>
                {{ 'DROPDOWN.Alert' | translate }}
              </div>
              <div>
                <i class="fa fa-light fa-bell m-x-xs text-warn"></i>
                {{ 'DROPDOWN.Warning' | translate }}
              </div>
              <div>
                <i class="fa fa-light fa-bell m-x-xs text-success"></i>
                {{ 'DROPDOWN.Information' | translate }}
              </div>
            </ng-template>
          </th>
          <th gp-table-column sort-key="transId">{{ 'PAYROLL_EVENTS.event' | translate }}</th>
          <th gp-table-column width="70">
            <div class="pull-right">
              <button class="btn btn-sm btn-icon white"
                      tooltip="{{ 'TOOLTIPS.filters' | translate }}"
                      [class.active]="filtersVisible"
                      [disabled]="!events === null || !events?.length"
                      (click)="filtersVisible = !filtersVisible">
                <i class="fa fa-light fa-filter pointer"></i>
              </button>
            </div>
          </th>
        </tr>
        <tr class="row filters" #filters
            [attr.data-hidden]="!filtersVisible">
          <td>
            <select class="form-control"
                    [attr.readOnly]="isPayTypeFilterDisabled ? 'true' : null"
                    formControlName="payTypeTransId">
              <option></option>
              <option *ngFor="let payType of payTypes"
                      [value]="payType.transId">
                {{payType.transId | translate}}
              </option>
            </select>
          </td>

          <td>
            <select class="form-control" formControlName="payroll">
              <option></option>
              <option *ngFor="let payPeriod of payPeriods | sortByTranslations:
                         triggerSortByTranslationPipe :['attributes.serie.transid','attributes.transid'] | async"
                      [value]="payPeriod.attributes.serie.transid + ',' + payPeriod.attributes.transid">
                {{ payPeriod.attributes.serie.transid | translate }} -
                {{ payPeriod.attributes.transid | translate }}
              </option>
            </select>
          </td>
          <td></td>
          <td>
            <input formControlName="name" type="text" class="form-control">
          </td>
          <td></td>
          <td></td>
          <td>
            <select class="form-control" formControlName="eventType">
              <option></option>
              <option *ngFor="let eventType of eventTypes | sortByTranslations:
                        triggerSortByTranslationPipe :['name'] | async" [value]="eventType.key">
                {{eventType.name | translate}}
              </option>
            </select>
          </td>
          <td></td>
          <td>
          </td>
        </tr>
        </thead>
        <tbody #tableBody>
        <tr *ngIf="events == null">
          <td colspan="9" class="text-center p-t-lg p-b-lg">
            <i class="fa fa-light fa-spinner fa-spin"></i>
          </td>
        </tr>
        <tr *ngIf="events != null && events.length == 0">
          <td colspan="9" class="text-center p-t-lg p-b-lg">
            <gp-illustrated-message
              [text]="'PAYROLL_EVENTS.no_event_found'"
              [type]="'NO_SEARCH_RESULTS'"
              [width]="'30%'">
            </gp-illustrated-message>
          </td>
        </tr>
        <tr *ngFor="let event of events; let i = index">
          <td>{{event.payTypeTransId}}</td>
          <td>{{ event.payRollSerieName | translate }} - {{ event.payRollPeriodsName |
            translate}}
          </td>
          <td>{{ event.contractID }}</td>
          <td><a [routerLink]="['/employees/files', event.contractID]">
            <span class="text-uppercase">{{ event.cliEmpLastName }}</span>
            {{ event.cliEmpfirstName }}</a></td>
          <td>
            <span>
            {{ event.payExecTimeStamp ? (event.payExecTimeStamp | amDateFormat:'MM/DD - HH:mm') : '-' }}
            </span>
          </td>
          <td>{{ event.rule | translate }}</td>
          <td>
            <i class="fa fa-light fa-bell m-x-xs"
               [ngClass]="{
                'text-black': event.eventType === 'ERROR_TECHNIC',
                'text-danger': event.eventType === 'ALERT',
                'text-warn': event.eventType === 'WARNING',
                'text-success': event.eventType === 'INFORMATION'
               }"></i>
          </td>
          <td class="pointer hover-underline" style="word-break: break-word" (click)="openEvent(event)">
            <span *ngIf="event.eventType !== 'ERROR_TECHNIC' || isAdministrator; else errorTechnic">
             {{ event.transId | translate:{args: event.args} }}
            </span>
            <ng-template #errorTechnic>
              {{'PAYROLL_EVENTS.technical_error' | translate}}
            </ng-template>
          </td>
          <td>
            <div gp-roles
                 [userRoles]="['PAYROLL_WRITE']"
                 *ngIf="event.status == 'TODO' && !event.readOnly"
                 (click-outside)="event.dropdownOpen = false"
                 class="dropdown inline pull-right"
                 [class.open]="event.dropdownOpen">
              <button class="btn btn-xs btn-outline b-warning text-warning"
                      (click)="selectedActions.has(event.id) ? deleteEvent(event.id) : toggleDropdown(event, dropdown, tableBody)"
                      [ngClass]="selectedActions.has(event.id) ? 'active' : 'inactive'">
                {{ 'COMMON.done' | translate }}
              </button>
              <div class="dropdown-menu pull-right" #dropdown>
                <div class="text-center">
                  <strong>{{ 'PAYROLL_EVENTS.done_for' | translate }}:</strong>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item">
                  <label class="checkbox">
                    <input type="radio" class="has-value"
                           [name]="'employeeUnit' + i" value="employee" checked
                           (change)="event.employeeUnit = extractValue($event.target)">
                    {{ 'PAYROLL_EVENTS.this_employee' | translate }}
                  </label>
                </div>
                <div class="dropdown-item"
                     *ngIf="event.eventType != 'ERROR_TECHNIC'">
                  <label class="checkbox">
                    <input type="radio" [name]="'employeeUnit' + i" value="all"
                           (change)="event.employeeUnit = extractValue($event.target)">
                    {{ 'PAYROLL_EVENTS.all_employees' | translate }}
                  </label>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-item">
                  <label class="checkbox">
                    <input type="radio" checked [name]="'timeUnit' + i" value="calculation"
                           (change)="event.timeUnit = extractValue($event.target)">
                    {{ 'PAYROLL_EVENTS.this_calculation' | translate }}
                  </label>
                </div>
                <div class="dropdown-item"
                     *ngIf="event.eventType != 'ERROR_TECHNIC'">
                  <label class="checkbox">
                    <input type="radio" [name]="'timeUnit' + i" value="period"
                           (change)="event.timeUnit = extractValue($event.target)">
                    {{ 'PAYROLL_EVENTS.this_period' | translate }}
                  </label>
                </div>
                <div class="dropdown-item"
                     *ngIf="event.eventType != 'ERROR_TECHNIC'">
                  <label class="checkbox">
                    <input type="radio" [name]="'timeUnit' + i" value="forever"
                           (change)="event.timeUnit = extractValue($event.target)">
                    {{ 'PAYROLL_EVENTS.all_the_time' | translate }}
                  </label>
                </div>
                <div class="text-center p-a-sm">
                  <button class="btn btn-sm info" (click)="selectForDone(event, 'DONE');">
                    {{ 'PAYROLL_EVENTS.ok' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div gp-roles
                 [userRoles]="['PAYROLL_WRITE']"
                 class="dropdown inline pull-right" [class.open]="event.dropdownOpen"
                 *ngIf="(event.status === 'DONE' || event.status === 'DONE_BYEXCEPTION') && !event.readOnly">
              <button class="btn btn-xs btn-outline-primary"
                      (click)="selectedActions.has(event.id) ? selectedActions.delete(event.id) : selectForDone(event, 'UNDO')"
                      [ngClass]="selectedActions.has(event.id) ? 'active' : 'inactive'">
                {{ 'PAYROLL_EVENTS.undo' | translate }}
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </gp-table>
    </div>

    <footer class="dker p-a" gp-sticky="bottom" [refreshOn]="dataLoaded">
      <div class="row">
        <div class="col-sm-8 col-lg-9 text-center text-center-xs">
          <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
            <li class="page-item" [class.disabled]="!pagination.hasPrevious()">
              <a class="page-link" (click)="pagination.hasPrevious() && pagination.first()">
                <i class="fa fa-light fa-angle-double-left" aria-hidden="true"></i>
              </a>
            </li>
            <li class="page-item" [class.disabled]="!pagination.hasPrevious()">
              <a class="page-link" (click)="pagination.hasPrevious() && pagination.previous()">
                <i class="fa fa-light fa-angle-left" aria-hidden="true"></i>
              </a>
            </li>
            <li *ngFor="let page of pagination.pages()" class="page-item"
                [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
              <a *ngIf="page > 0" class="page-link" (click)="pagination.goToPage(page - 1)">{{ page }}</a>
              <a *ngIf="page < 1" class="page-link default-cursor">…</a>
            </li>
            <li class="page-item" [class.disabled]="!pagination.hasNext()">
              <a class="page-link" (click)="pagination.hasNext() && pagination.next()">
                <i class="fa fa-light fa-angle-right" aria-hidden="true"></i>
              </a>
            </li>
            <li class="page-item" [class.disabled]="!pagination.hasNext()">
              <a class="page-link" (click)="pagination.hasNext() && pagination.last()">
                <i class="fa fa-light fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
        <div gp-roles
             [userRoles]="['PAYROLL_WRITE']"
             class="col-sm-4 col-lg-3 text-right text-center-xs">
          <div class="pull-right">
            <button class="btn btn-sm dark-white p-x-md" type="button" [disabled]="!selectedActions.size"
                    (click)="clear()">
              {{ 'COMMON.reset' | translate }}
            </button>
            <button class="btn btn-sm btn-fw warn" (click)="executeSelectedActions()"
                    [disabled]="!selectedActions.size">
              <i class="fa fa-light fa-caret-square-right pull-right" aria-hidden="true"></i>
              {{ 'COMMON.execute' | translate }}
            </button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>
